<template>
  <div v-show="loaded">
    <slot></slot>
  </div>
</template>
<script>
export function triggerLoaded($vm) {
  let $parent = $vm.$parent;
  while ($parent && $parent.$options.name != 'LoadContainer') {
    $parent = $parent.$parent;
  }
  if ($parent && $parent.$options.name == 'LoadContainer') {
    $parent.triggerLoaded();
  }
}

export default {
  name: 'LoadContainer',
  props: {
    isLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: this.isLoaded,
    };
  },
  watch: {
    isLoaded(value) {
      this.loaded = value;
    },
    loaded(value) {
      this.$emit('update:isLoaded', value);
    },
  },
  methods: {
    triggerLoaded() {
      this.loaded = true;
    },
  },
};
</script>
